import { render } from "./list-denounces.vue?vue&type=template&id=2781fc3a&ts=true"
import script from "./list-denounces.vue?vue&type=script&lang=ts"
export * from "./list-denounces.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__